module.exports = __webpack_public_path__ + "static/9-368557e5b0689c3a0febf7645ccf9973.jpg";